import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { closeSweetAlertStyle } from '../../helpers/CustomStyles';
import { connect } from 'react-redux';
import { getSystemFiles } from '../../stores/actions/dashboardActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import CancelIcon from '@material-ui/icons/Cancel';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon.js';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import DescriptionOutlined from '@material-ui/icons/DescriptionOutlined';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React from 'react';
import styles from '../../assets/jss/views/dashboardStyle';
import SystemDocumentationCardBody from './SystemDocumentationCardBody';


const style = {
	cardTitle,
	cardCategory: styles.cardCategory,
};


interface ISystemDocumentationCardProps {
	hideAlert: () => void;
	systemVersion: string;
	systemFiles: any;
}

class SystemDocumentationCard extends React.Component<ISystemDocumentationCardProps> {
	render() {
		const { systemFiles } = this.props;
        const headerText = 'Files';

		return (
			<ErrorComponent Children message='Error'>
				<GridContainer>
					<GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button
							simple
							justIcon
							color='info'
							style={closeSweetAlertStyle}
							onClick={this.props.hideAlert}
							data-testid='cancelButton'
						>
							<CancelIcon style={{ width: '20px', height: '20px' }} />
						</Button>
					</GridItem>
				</GridContainer>

				<Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} data-testid='systemDocumentationCard'>

					<CardHeader color='info' icon>
						<CardIcon color='info'>
							<DescriptionOutlined />
						</CardIcon>
						<p style={{ ...style.cardCategory, textAlign: 'left' }}>{headerText}</p>
						<h3 style={{ ...style.cardTitle, textAlign: 'left', marginLeft: '20%', marginTop: '10px' }}>{''}</h3>
					</CardHeader>

					<SystemDocumentationCardBody
						hideAlert={this.props.hideAlert}
						files={systemFiles}
					/>
				</Card>
			</ErrorComponent>
		);
	}
}


const mapStateToProps = (state) => {
    return {
        systemFiles: state.dashboard.systemFiles,
    }
}
const actions = { getSystemFiles };
export const ExportCardWithStyles = dashboardStyle(SystemDocumentationCard);
export default connect(mapStateToProps, actions)(ExportCardWithStyles);
